import { LogError } from "../../utils/ErrorTelemetry";
import { LogEvents } from "../../utils/LogEvents";
import { LogEventNames } from "../interfaces/ITelemetryLogger";
import { HostAppSettingName, HostAppSettings } from "../office-js/HostAppSettings";
import { FileUploadKeys } from "../telemetry/FileUploadKeys";


export class TranscriptionHistoryDump {
  private HistoryDumpSet = new Set<string>();

  public AddEventToTranscriptionHistory(eventStr: string) {
    let date = new Date();
    let timeStamp = date.getUTCFullYear()+'-' + (date.getUTCMonth() + 1) + '-' + date.getUTCDate() +
    " " + date.getUTCHours() + ":" + date.getUTCMinutes() + ":" + date.getUTCSeconds();
    this.HistoryDumpSet.add(timeStamp + " msg : "+eventStr);
  }

  public LogTranscriptionHistory(eventName: LogEventNames, initialMsg: string) {
    const transcriptionSessionId: string = HostAppSettings.GetSettingAsString(HostAppSettingName.TranscriptionSessionId);
    let historyStr = 'transcriptionSessionId: ' + transcriptionSessionId + '\n';
    this.HistoryDumpSet.forEach(event => {
      historyStr += event + '\n';
    });
    const message = initialMsg + " [ " + historyStr + " ]";
    switch(eventName) {
      case LogEventNames.FileUpload:
        LogEvents.FileUpload.AddData([{ key: FileUploadKeys.FileUploadHistoryDump, value: message }]);
        break;
      default:
        LogError(eventName, message);
        break;
    }

    this.HistoryDumpSet.clear();
  }
}